import _ from 'lodash'
import { useMemo, useState } from 'react'
import { Form, Icon, Label, Menu, Message } from 'semantic-ui-react'
import { _sdm } from '../../../../projectSpecific/sports/elements/dashboard/SportsDashboard'
import WrapperVertCols from '../../../wrappers/WrapperVertCols'
import TransitionWrapper from '../../../wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'

const UiSideMenuWrapper = (props) => {

  const {
    isContent,
    showItemKey,
    sportsDataMode,
    contentElements,
    menuItems,
    menuObjects
  } = props


  const [currentItem, setCurrentItem] = useState()
  const [currentItemKey, setCurrentItemKey] = useState()

  const handleItemSelect = (team) => {
    setCurrentItem(team)
    props.setCurrentMenuKey(team._itemKey)
    setCurrentItemKey(team._itemKey)
  }

  const ims = useMemo(() => {
    if (!menuItems) return []
    const _menuItems = _.map(menuItems, (mi, mik) => (
      {
        name: mi.name,
        count: menuObjects?.[mik]?.length || null,
        _itemKey: mi?._itemKey
      }
    ))
    console.log('_menuItems', _menuItems)
    console.log('menuObjects', menuObjects)
    let _caption = sportsDataMode.replace('access', '')
    _caption = _caption.replace('contacts', '')
    _caption = _caption.replace('gls', '')
    _caption = _caption.replace('Rosters', '')
    return <Wrapper
      header={_.startCase(_caption)}
      content={<TransitionWrapper>
        <ItemMenuSquares
          menuItems={_.sortBy(_menuItems, 'name')}
          onClick={handleItemSelect}
          activeItem={currentItemKey}
          imsType={_imsTypes.inline}
          icon={'Users'}
        />
      </TransitionWrapper>}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  }, [sportsDataMode, menuItems, currentItemKey])

  const description = useMemo(() => {
    let _description;
    switch (sportsDataMode) {
      case _sdm.district.glsScores:
        _description = 'These are the settings for Scores Access to the App';
        break;
      case _sdm.sports.glsTeam:
        _description = 'These are the settings for Team Access to the App';
        break;
      case _sdm.sports.accessTeams:
        _description = 'These are the settings for Team Access to the App';
        break;
      case _sdm.sports.teamRosters:
        _description = 'These are the team rosters';
        break;
      default:
        _description = 'These are the settings for District Access to the App';
    }
    return <Message content={_description} color='black' />
  }, [])

  const wrapper_form = () => <Wrapper
    header={currentItem ? _.startCase(sportsDataMode) + ' - ' + currentItem.name : _.startCase(sportsDataMode)}
    content={<TransitionWrapper>
      <Form>
        {contentElements}
      </Form>
    </TransitionWrapper>}
    wrapperType={wrapperTypes.padded
    }
  />

  const contentContent = useMemo(() => {
    if (isContent) {
      return <div style={{ height: '100%' }}>{contentElements}</div>
    } else {
      return wrapper_form()
    }
  }, [contentElements])

  const content = () => <WrapperVertCols mvc={'1-5'}>
    {ims}
    {contentContent}
  </WrapperVertCols>

  return content()
}

export default UiSideMenuWrapper